/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedLocationListAdmin } from './PaginatedLocationListAdmin'
import {
  PaginatedLocationListAdminFromJSON,
  PaginatedLocationListAdminFromJSONTyped,
  PaginatedLocationListAdminToJSON,
} from './PaginatedLocationListAdmin'

/**
 *
 * @export
 * @interface EnvelopedLocationListLocationListAdmin
 */
export interface EnvelopedLocationListLocationListAdmin {
  /**
   *
   * @type {PaginatedLocationListAdmin}
   * @memberof EnvelopedLocationListLocationListAdmin
   */
  body: PaginatedLocationListAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedLocationListLocationListAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedLocationListLocationListAdmin interface.
 */
export function instanceOfEnvelopedLocationListLocationListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedLocationListLocationListAdminFromJSON(
  json: any,
): EnvelopedLocationListLocationListAdmin {
  return EnvelopedLocationListLocationListAdminFromJSONTyped(json, false)
}

export function EnvelopedLocationListLocationListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedLocationListLocationListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedLocationListAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedLocationListLocationListAdminToJSON(
  value?: EnvelopedLocationListLocationListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedLocationListAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
